import { render } from "./PulllistPage.vue?vue&type=template&id=49051344"
import script from "./PulllistPage.vue?vue&type=script&lang=js"
export * from "./PulllistPage.vue?vue&type=script&lang=js"

import exportComponent from "/Users/mhall/dev/rorserver/newcomb/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__